import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import apiRoutes from '../../../../config/api/routes';
import { IGroupAssignment, ITeacherAssignment } from '../../../../config/api/models/Assignment';
import theme from '../../../../config/theme';
import { useFetch } from '../../../shared/hooks';
import { Icons, ListItem, ProfilePicture, SvgIcon } from '../../../shared/components';
import { Theme, styled } from '@material-ui/core';

type Props = {
  assignment: ITeacherAssignment;
  expanded: boolean;
};

const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const ListItemWrapper = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  width: '100%',

  '&:nth-child(odd) .listItem': {
    width: '100%',
    background: theme.palette.background.default,
  },
}));

const UserDetails = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '30rem',
});

const UserName = styled('div')<Theme>(({ theme }) => ({
  marginLeft: theme.spacing(2),
  fontSize: theme.typography.h4.fontSize,
}));

const StyledCheckIcon = styled(SvgIcon)({
  position: 'absolute',
  top: '50%',
  right: '1rem',
  transform: 'translateY(-50%)',
});

const AssignmentFollowUp: FC<Props> = ({ assignment, expanded }) => {
  const { t } = useTranslation();
  const [getGroupAssignmentsResponse, getGroupAssignments] = useFetch<IGroupAssignment[]>(
    apiRoutes.groupAssignments(assignment.groupId, assignment.id)
  );

  useEffect(() => {
    if (expanded) {
      getGroupAssignments();
    }
  }, [expanded, getGroupAssignments, assignment]);

  return (
    <>
      {getGroupAssignmentsResponse.pending && <span>{t('shared.loading')}</span>}
      {getGroupAssignmentsResponse.success ? (
        <Wrapper>
          {getGroupAssignmentsResponse.data.map((studentAssignment: IGroupAssignment) => (
            <ListItemWrapper key={studentAssignment.id}>
              <ListItem className="listItem" actions={[]}>
                <UserDetails>
                  <ProfilePicture size="small" initials={studentAssignment.initials} />
                  <UserName>{`${studentAssignment.fullName}`}</UserName>
                </UserDetails>
                {studentAssignment.completedAt ? (
                  <StyledCheckIcon color={theme.palette.completed.dark} icon={Icons.CHECK} />
                ) : null}
              </ListItem>
            </ListItemWrapper>
          ))}
        </Wrapper>
      ) : null}
    </>
  );
};

export default AssignmentFollowUp;
